import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const CARD_BASE = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';

const LABELS = ['A. Don', 'B. Amar Akbar Anthony', 'C. Sahib Bibi Aur Ghulam', 'D. Dharam Veer', 'E. Kis Kis ko Pyaar Karoon', 'F. Ghulam'];
const CARD_FACES = ['J', 'Q', 'K', 'A'];

function findBySid(sub, sid) {
  return sub.find((s) => Number(s.sid) === sid);
}

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function formatAmount(n) {
  const num = Number(n) || 0;
  if (num >= 100000) return `${num / 100000}L`;
  if (num >= 1000) return `${num / 1000}K`;
  return String(num);
}

function bookOf(exposures, item) {
  const v = exposures?.[`sid:${item?.sid}`] ?? exposures?.[item?.nat];
  return v ? roundBook(v) : 0;
}

function bookCls(v) {
  if (!v) return 'book-black';
  return v < 0 ? 'book-red' : 'book-green';
}

// reference: har section ke neeche min-max block
function MinMax({ item, fallbackMax = 100000, indent = '                    ', fullWidth = true }) {
  return (
    <div className={`teen1daycasino-container justify-content-end casino-min-max${fullWidth ? ' w-100' : ''}`}>
      <div>
        {`\n${indent}R:`}
        <span>{formatAmount(item?.min ?? 100)}</span>
        {`\n${indent}-\n${indent}`}
        <span>{formatAmount(item?.max ?? fallbackMax)}</span>
      </div>
    </div>
  );
}

// Bollywood Casino 2 (btable2) — admin reference: casino-table aaa.
// Mobile (d-none-big): 6 movies + Odd stacked back/lay boxes with book-black
// spans + min-max blocks; desktop (d-none-small): movies 3-col grid + Odd
// col; dono views me bc-fancy (Dulha/Barati), aaa-oe (Red pehle, phir
// Black) aur Cards J/Q/K/A sections. Sids: 1-6 movies (match spread),
// 7 Odd (fancy1), 8 Red / 9 Black / 10-13 cards / 14 Dulha / 15 Barati
// (fancy singles).
const BetTableBtable2 = memo(function BetTableBtable2({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const mainItems = [1, 2, 3, 4, 5, 6].map((sid) => findBySid(sub, sid));
  const odd = findBySid(sub, 7);
  const red = findBySid(sub, 8);
  const black = findBySid(sub, 9);
  const cardItems = [10, 11, 12, 13].map((sid) => findBySid(sub, sid));
  const dulha = findBySid(sub, 14);
  const barati = findBySid(sub, 15);
  const cardsOdds = cardItems[0]?.b ?? 0;

  const backLay = (item) => (
    <>
      <div
        className={`back casino-bl-box-item${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
      >
        <span className="casino-box-odd">{item?.b ?? 0}</span>
      </div>
      {' '}
      <div
        className={`lay casino-bl-box-item${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}
      >
        <span className="casino-box-odd">{item?.l ?? 0}</span>
      </div>
    </>
  );

  return (
    <>
      {/* MOBILE: movies + Odd stacked */}
      <div className="row row5 d-none-big">
        {mainItems.map((item, i) => (
          <div key={i} className="casino-bl-box">
            <div className="casino-bl-box-item casino-odds-name">
              <b>{LABELS[i]}</b>
              {' '}
              <span className={`float-right ${bookCls(bookOf(exposures, item))}`}>{fmtBook(bookOf(exposures, item))}</span>
            </div>
            {' '}
            {backLay(item)}
          </div>
        ))}
        {' '}
        <MinMax item={mainItems[0]} />
        {' '}
        <div className="casino-bl-box">
          <div className="casino-bl-box-item casino-odds-name">
            <b>Odd</b>
            {' '}
            <span className={`float-right ${bookCls(bookOf(exposures, odd))}`}>{fmtBook(bookOf(exposures, odd))}</span>
          </div>
          {' '}
          {backLay(odd)}
        </div>
        {' '}
        <MinMax item={odd} />
      </div>
      {' '}
      {/* DESKTOP: movies 3-col grid */}
      <div className="row row5 d-none-small">
        {mainItems.map((item, i) => (
          <div key={i} className="col-4">
            <div className="casino-box-row">
              <div className="casino-nation-name"><b>{LABELS[i]}</b></div>
              {' '}
              <div className="casino-bl-box">
                {backLay(item)}
              </div>
              {' '}
              <div className={`casino-book text-center ${bookCls(bookOf(exposures, item))}`}>{fmtBook(bookOf(exposures, item))}</div>
            </div>
          </div>
        ))}
        {' '}
        {/* reference desktop: wrapped in col-12, no w-100 */}
        <div className="col-12">
          <MinMax item={mainItems[0]} indent={'                      '} fullWidth={false} />
        </div>
      </div>
      {' '}
      {/* Odd (desktop) + Dulha + Barati */}
      <div className="row row5">
        <div className="col-lg-4 col-12 d-none-small">
          <div className="casino-box-row">
            <div className="casino-nation-name"><b>Odd</b></div>
            {' '}
            <div className="casino-bl-box">
              {backLay(odd)}
            </div>
            {' '}
            <div className={`casino-book text-center ${bookCls(bookOf(exposures, odd))}`}>{fmtBook(bookOf(exposures, odd))}</div>
            {' '}
            <MinMax item={odd} indent={'                      '} />
          </div>
        </div>
        {' '}
        <div className="col-lg-4 col-6 bc-fancy">
          <div className="casino-box-row">
            <div className="casino-nation-name"><b>{dulha?.b ?? 0}</b></div>
            {' '}
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item${suspCls(dulha)}`}
                onClick={isSusp(dulha) ? undefined : () => handleBet(dulha.sid, 'back', dulha.b, dulha)}
              >
                <span className="casino-box-odd">Dulha Dulhan K-Q</span>
              </div>
              {' '}
              <span className={`casino-book text-center ${bookCls(bookOf(exposures, dulha))}`}>{fmtBook(bookOf(exposures, dulha))}</span>
            </div>
          </div>
          {' '}
          <MinMax item={dulha} />
        </div>
        {' '}
        <div className="col-lg-4 col-6 bc-fancy">
          <div className="casino-box-row">
            <div className="casino-nation-name"><b>{barati?.b ?? 0}</b></div>
            {' '}
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item${suspCls(barati)}`}
                onClick={isSusp(barati) ? undefined : () => handleBet(barati.sid, 'back', barati.b, barati)}
              >
                <span className="casino-box-odd">Barati J-A</span>
              </div>
              {' '}
              <span className={`casino-book text-center ${bookCls(bookOf(exposures, barati))}`}>{fmtBook(bookOf(exposures, barati))}</span>
            </div>
          </div>
          {' '}
          <MinMax item={barati} />
        </div>
      </div>
      {' '}
      {/* Red/Black suits + Cards */}
      <div className="row row5">
        <div className="col-lg-6 col-12 aaa-oe">
          <div className="casino-box-row">
            <div className="casino-bl-box"><b>{red?.b ?? 0}</b></div>
            {' '}
            <div className="casino-bl-box"><b>{black?.b ?? 0}</b></div>
          </div>
          {' '}
          <div className="casino-box-row">
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item casino-card-img${suspCls(red)}`}
                onClick={isSusp(red) ? undefined : () => handleBet(red.sid, 'back', red.b, red)}
              >
                <span>
                  <img src={`${CARD_BASE}/heart.png`} />
                  {' '}
                  <img src={`${CARD_BASE}/diamond.png`} />
                </span>
              </div>
              {' '}
              <span className={`casino-book text-center ${bookCls(bookOf(exposures, red))}`}>{fmtBook(bookOf(exposures, red))}</span>
            </div>
            {' '}
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item casino-card-img${suspCls(black)}`}
                onClick={isSusp(black) ? undefined : () => handleBet(black.sid, 'back', black.b, black)}
              >
                <span>
                  <img src={`${CARD_BASE}/spade.png`} />
                  {' '}
                  <img src={`${CARD_BASE}/club.png`} />
                </span>
              </div>
              {' '}
              <span className={`casino-book text-center ${bookCls(bookOf(exposures, black))}`}>{fmtBook(bookOf(exposures, black))}</span>
            </div>
          </div>
          {' '}
          <MinMax item={red} />
        </div>
        {' '}
        <div className="col-lg-6 col-12">
          <div className="text-center w-100">
            <div className="casino-bl-box">
              <div className="casino-bl-box-item"><b>Cards {cardsOdds}</b></div>
            </div>
          </div>
          {' '}
          <div className="casino-cards text-center mt-1">
            {cardItems.map((item, i) => (
              <div key={i} className="casino-card-item">
                <div
                  className={`card-image${suspCls(item)}`}
                  onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
                >
                  <img src={`${CARD_BASE}/${CARD_FACES[i]}.png`} />
                </div>
                {' '}
                <div className={`casino-book text-center ${bookCls(bookOf(exposures, item))}`}>{fmtBook(bookOf(exposures, item))}</div>
              </div>
            ))}
          </div>
          {' '}
          <MinMax item={cardItems[0]} fallbackMax={25000} />
        </div>
      </div>
    </>
  );
});

export default BetTableBtable2;
